// extracted by mini-css-extract-plugin
export default {"activePowerTable":"PVRealityPower_activePowerTable__gdaka"};